import { ContactsApiProvider } from './contactsapi.services';
import Axios from 'axios';
import { toggleReadLoader } from 'actions';
import _ from 'lodash';
import { appendUrlParameters } from '../utils/urlparams.service';
const CancelToken = Axios.CancelToken;
let tokenCancel = '';
const envResponse = Axios.get('/env_config/config.json');

export const fetchMemberContacts = (memberKey, embed = null, createdAfter = null, modifiedAfter = null, emailAddress = null, sort = null, page = null, pageSize = null) => async dispatch => {
  const envData = await envResponse;
  tokenCancel && tokenCancel();
  try {
    dispatch(toggleReadLoader(true));
    var url = appendUrlParameters(`/members/${memberKey}/contacts`, [['embed', embed], ['createdAfter', createdAfter], ['modifiedAfter', modifiedAfter], ['emailAddress', emailAddress], ['sort', sort], ['page', page], ['pageSize', pageSize]]);

    const response = Axios.request({
      baseURL: await _.get(envData, 'data.contactsApiUrl', ''),
      url: url,
      method: 'GET',
      headers: await ContactsApiProvider.setHeader(),
      cancelToken: new CancelToken(function executor (c) { tokenCancel = c; })
    });
    dispatch(toggleReadLoader(false));
    return response;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const fetchAssignedContacts = (memberKey, embed = null, search = null, filterType = null, sort = null, page = null, pageSize = null, start = null, end = null) => async dispatch => {
  const envData = await envResponse;
  tokenCancel && tokenCancel();
  try {
    dispatch(toggleReadLoader(true));
    var url = appendUrlParameters(`/members/${memberKey}/assignedcontacts`, [['embed', embed], ['search', search], ['filterType', filterType], ['sort', sort], ['page', page], ['pageSize', pageSize], ['start', start], ['end', end]]);
    const response = Axios.request({
      baseURL: await _.get(envData, 'data.contactsApiUrl', ''),
      url: url,
      method: 'GET',
      headers: await ContactsApiProvider.setHeader(),
      cancelToken: new CancelToken(function executor (c) { tokenCancel = c; })
    });
    dispatch(toggleReadLoader(false));
    return response;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const fetchReferralsCountForAgent = (memberKey, filterType, search = null, start = null, end = null) => {
  var url = appendUrlParameters(`/members/${memberKey}/contacts/count`, [['filterType', filterType], ['search', search], ['start', start], ['end', end]]);
  return ContactsApiProvider.get(url);
};

export const fetchContact = (contactKey, embed = null) => {
  var url = appendUrlParameters(`/contacts/${contactKey}`, [['embed', embed]]);
  return ContactsApiProvider.get(url);
};

export const putUpdateContact = (contactId, contact) => {
  return ContactsApiProvider.put(`/contacts/${contactId}`, contact);
};

export const patchUpdateContact = (contactId, contact) => {
  return ContactsApiProvider.patch(`/contacts/${contactId}`, contact);
};

export const fetchContactProperties = (contactId) => {
  return ContactsApiProvider.get(`/contacts/${contactId}/properties/`);
};
